/**
 * @fileoverview SAP Movement table component
 * Displays material movements synchronized from SAP
 */
import React, { forwardRef, useCallback, useMemo } from "react";
import { formatDate } from '../../utils/formatters';
import PropTypes from "prop-types";
import { intl } from "dmsbasereact";
import { Chip } from "@mui/material";
import { DmsEntityTable } from "../DmsEntityTable";

/**
 * SAP Movement table component using DmsEntityTable
 */
const SapMovementTable = forwardRef(({ onViewDetails = null }, ref) => {
  // Column definitions
  const columns = useMemo(() => [
    {
      label: intl.get("DocumentNumber").d("Document Number"),
      column_name: "document_number",
      filter: true,
      width: "150px",
    },
    {
      label: intl.get("MaterialCode").d("Material Code"),
      column_name: "material_code",
      filter: true,
      width: "130px",
    },
    {
      label: intl.get("MaterialDescription").d("Description"),
      column_name: "batch.part.description",
      width: "200px",
      sortable: false,
      filter: false,
      element: (row) => row.batch?.part?.description || "-",
    },
    {
      label: intl.get("BatchNumber").d("Batch"),
      column_name: "batch.number",
      filter: true,
      width: "120px",
      sortable: false,
      element: (row) => row.batch?.number || "-",
    },
    {
      label: intl.get("Quantity").d("Quantity"),
      column_name: "quantity",
      width: "120px",
      function: (value, row) => value ? `${value.toLocaleString("pt-BR")} ${row.unit}` : "0",
    },
    {
      label: intl.get("MovementType").d("Movement Type"),
      column_name: "movement_type",
      width: "130px",
      element: (row) => {
        const typeText = row.movement_type_text || row.movement_type;
        return (
          <Chip 
            label={typeText} 
            size="small" 
            color="primary" 
            variant="outlined"
          />
        );
      },
    },
    {
      label: intl.get("Plant").d("Plant"),
      column_name: "plant",
      width: "100px",
    },
    {
      label: intl.get("ProductionDate").d("Production Date"),
      column_name: "production_date",
      width: "120px",
      function: formatDate,
    },
  ], []);

  // View details handler
  const handleViewDetails = useCallback((row) => {
    if (onViewDetails) {
      onViewDetails(row);
    }
  }, [onViewDetails]);

  return (
    <DmsEntityTable
      ref={ref}
      url="/sap-movement/table"
      columns={columns}
      onView={handleViewDetails}
      hideDelete={true}
      hideBlock={true}
      hideCreate={true}
      hidePdf={true}
      hideExport={true}
      createButtonLabel={intl.get("SapMovementsReadOnly").d("Dados sincronizados do SAP (somente leitura)")}
    />
  );
});

SapMovementTable.displayName = "SapMovementTable";

SapMovementTable.propTypes = {
  onViewDetails: PropTypes.func,
};


export { SapMovementTable };


